<svelte:head>
	<link rel="preconnect" href="https://www.googletagmanager.com" />

	<!-- Google Tag Manager -->
	<script class="gtm-script">
		(function (w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s),
				dl = l != 'dataLayer' ? '&l=' + l : '';
			j.async = true;
			j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
			f.parentNode.insertBefore(j, f);
		})(window, document, 'script', 'dataLayer', 'GTM-WKMRPZQ9');
	</script>
	<!-- End Google Tag Manager -->

	<!-- Google Analytics GA4 -->
	<script
		async
		src="https://www.googletagmanager.com/gtag/js?id=G-X6VGHGQMK1"
	></script>

	<script class="gtag-script">
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag('js', new Date());
		gtag('config', 'G-X6VGHGQMK1');
	</script>
	<!-- End Google Analytics -->

	<!-- Google Tag Manager (noscript) -->
	<noscript>
		<iframe
			src="//www.googletagmanager.com/ns.html?id=GTM-WKMRPZQ9"
			height="0"
			width="0"
			title="gtm"
			style="display: none; visibility: hidden;"
		></iframe>
	</noscript>
	<!-- End Google Tag Manager (noscript) -->
</svelte:head>
